/**
 * Formats typed digits as MM-DD-YYYY, inserting the dashes for the user.
 *
 * Used on phone sign-up, where the birth date field shows a numeric keypad
 * that has no "-" key on iOS. Anything that isn't a digit is dropped, and
 * input is capped at 8 digits.
 */
export const formatBirthDateInput = (text) => {
    const digits = text.replace(/\D/g, '').slice(0, 8);
    if (digits.length <= 2) {
        return digits;
    }
    if (digits.length <= 4) {
        return `${digits.slice(0, 2)}-${digits.slice(2)}`;
    }
    return `${digits.slice(0, 2)}-${digits.slice(2, 4)}-${digits.slice(4)}`;
};
